/* assets/scroll-core.js */
(function () {
  // Evitar dobles inits
  if (window.__SCROLL_CORE_READY__) return;
  window.__SCROLL_CORE_READY__ = true;

  // ---------- Infra de módulos ----------
  window.__SectionRegistry = window.__SectionRegistry || {};
  window.__SectionQueue = window.__SectionQueue || {};
  window.__flushSectionQueue = function (moduleName) {
    const q = window.__SectionQueue[moduleName];
    if (!q || !q.length || !window.__SectionRegistry[moduleName]) return;
    const init = window.__SectionRegistry[moduleName];
    while (q.length) {
      const w = q.shift();
      try { init(w); } catch (err) { console.error(`[${moduleName}] init error:`, err); }
    }
  };
  window.__enqueueSection = function (moduleName, wrapper) {
    window.__SectionQueue[moduleName] = window.__SectionQueue[moduleName] || [];
    window.__SectionQueue[moduleName].push(wrapper);
  };

  // ---------- Flags & estado ----------
  const prefersReduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const mqDesktop = window.matchMedia('(min-width: 1025px)');

  let lenis = null;
  let parallaxState = { els: [], onScroll: null, onResize: null, mo: null, active: false };
  let bridgeActive = false;

  // ---------- Helpers ----------
  function isLenisAvailable() { return typeof Lenis !== 'undefined'; }
  function hasGSAP() { return !!(window.gsap && window.ScrollTrigger); }

  function clearParallaxTransforms() {
    document.querySelectorAll('[data-parallax]').forEach(el => {
      el.style.transform = ''; // quitar translate aplicado
    });
  }

  // ---------- Lenis: enable/disable ----------
  function enableLenis() {
    if (lenis || !isLenisAvailable()) return;

    lenis = new Lenis({
      lerp: 0.1,
      smoothWheel: true,
      smoothTouch: false
    });
    window.lenis = lenis;

    // Reenganchar ScrollTrigger si existe
    if (window.ScrollTrigger) {
      lenis.on('scroll', ScrollTrigger.update);
    }

    // Si el parallax ya estaba activo, reenganchar su listener
    if (parallaxState.active && parallaxState.onScroll) {
      lenis.on('scroll', parallaxState.onScroll);
    }

    if (window.gsap) {
      const rafCallback = (t) => {
        if (!lenis) return;
        lenis.raf(t * 1000);
      };
      window.__lenisRafCallback = rafCallback;
      gsap.ticker.add(rafCallback);
      gsap.ticker.lagSmoothing(0);
    } else {
      const raf = (time) => {
        if (!lenis) return;
        lenis.raf(time);
        requestAnimationFrame(raf);
      };
      requestAnimationFrame(raf);
    }
  }

  function disableLenis() {
    if (!lenis) return;

    try {
      lenis.destroy?.();
    } catch (e) {
      console.warn('Error destroying Lenis', e);
    }

    lenis = null;
    delete window.lenis;

    document.documentElement.classList.remove('lenis', 'lenis-smooth', 'lenis-stopped');
  }

  // ---------- ScrollTrigger bridge ----------
  function enableBridge() {
    if (bridgeActive || !hasGSAP()) return;

    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.defaults({ scroller: document.documentElement });

    if (lenis) {
      lenis.on('scroll', ScrollTrigger.update);
    }

    ScrollTrigger.scrollerProxy(document.documentElement, {
      scrollTop(value) {
        if (arguments.length) window.scrollTo(0, value);
        else return window.pageYOffset || document.documentElement.scrollTop;
      },
      getBoundingClientRect() {
        return { top: 0, left: 0, width: window.innerWidth, height: window.innerHeight };
      },
      pinType: document.documentElement.style.transform ? 'transform' : 'fixed'
    });

    setTimeout(() => ScrollTrigger.refresh(), 0);

    // Editor de Shopify
    ['shopify:section:load','shopify:section:unload','shopify:block:select','shopify:block:deselect']
      .forEach(evt => {
        document.addEventListener(evt, () => setTimeout(() => ScrollTrigger.refresh(), 0));
      });

    bridgeActive = true;
  }

  function disableBridge() {
    if (!bridgeActive) return;
    if (hasGSAP()) {
      ScrollTrigger.killAll(false, true);
      ScrollTrigger.defaults({});
    }
    bridgeActive = false;
  }

  // ---------- Parallax estable ----------
  function enableParallax() {
    if (parallaxState.active || prefersReduce) return;

    const state = parallaxState;
    state.active = true;

    const vh = () => window.innerHeight;

    function pageOffsetTop(el) {
      let y = 0;
      while (el) { y += el.offsetTop || 0; el = el.offsetParent; }
      return y;
    }

    function collect() {
      state.els = Array.from(document.querySelectorAll('[data-parallax]'));
    }

    function computeBaselines() {
      for (const el of state.els) {
        const anchor = (el.getAttribute('data-anchor') || 'center').toLowerCase();
        const h = el.offsetHeight || el.getBoundingClientRect().height || 0;
        let anchorOffset = h / 2;
        if (anchor === 'top')    anchorOffset = 0;
        if (anchor === 'bottom') anchorOffset = h;
        el._baselineCenterPageY = pageOffsetTop(el) + anchorOffset;
      }
    }

    function currentScroll() {
      if (lenis && typeof lenis.scroll === 'number') return lenis.scroll;
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    function update() {
      const scrollY = currentScroll();
      const viewportCenterPageY = scrollY + vh() / 2;

      for (const el of state.els) {
        if (typeof el._baselineCenterPageY !== 'number') continue;

        const speed = parseFloat(el.getAttribute('data-parallax')) || 0.2;
        const maxOffset = parseFloat(el.getAttribute('data-max'));
        const delta = viewportCenterPageY - el._baselineCenterPageY;
        let y = -delta * speed;

        if (!isNaN(maxOffset)) {
          y = Math.max(-maxOffset, Math.min(maxOffset, y));
        }
        el.style.transform = `translate3d(0, ${y}px, 0)`;
      }
    }

    function refreshAll() {
      collect();
      computeBaselines();
      update();

      state.els.forEach(el => {
        el.querySelectorAll('img, video').forEach(m => {
          if (m.tagName === 'IMG' && !m.complete) {
            m.addEventListener('load', () => { computeBaselines(); update(); }, { once: true });
          }
          if (m.tagName === 'VIDEO') {
            m.addEventListener('loadeddata', () => { computeBaselines(); update(); }, { once: true });
          }
        });
      });
    }

    state.onScroll = () => update();
    state.onResize = () => { computeBaselines(); update(); };

    refreshAll();

    if (lenis) lenis.on('scroll', state.onScroll);
    else window.addEventListener('scroll', state.onScroll, { passive: true });

    window.addEventListener('resize', state.onResize, { passive: true });

    ['shopify:section:load','shopify:section:unload','shopify:block:select','shopify:block:deselect']
      .forEach(evt => {
        document.addEventListener(evt, refreshAll);
      });

    state.mo = new MutationObserver(() => refreshAll());
    state.mo.observe(document.body, { childList: true, subtree: true });
  }

  function disableParallax() {
    const state = parallaxState;
    if (!state.active) return;

    if (lenis && state.onScroll) {
      try { lenis.off?.('scroll', state.onScroll); } catch(e){}
    } else if (state.onScroll) {
      window.removeEventListener('scroll', state.onScroll);
    }
    if (state.onResize) window.removeEventListener('resize', state.onResize);
    if (state.mo) { try { state.mo.disconnect(); } catch(e){} }

    clearParallaxTransforms();

    state.els = [];
    state.onScroll = null;
    state.onResize = null;
    state.mo = null;
    state.active = false;
  }

  // --- Lock de scroll para Size Guide modal (sin tocar el body) ---
  document.addEventListener('size-guide:open', () => {
    if (!lenis) return;
    try {
      lenis.stop();
      document.documentElement.classList.add('lenis-stopped');
    } catch (e) {
      console.warn('Error al parar Lenis para size-guide:', e);
    }
  });

  document.addEventListener('size-guide:close', () => {
    if (!lenis) return;
    try {
      lenis.start();
      document.documentElement.classList.remove('lenis-stopped');
    } catch (e) {
      console.warn('Error al reanudar Lenis para size-guide:', e);
    }
  });

  // --- Lock para el modal de galería de producto ---
  document.addEventListener('product-media-modal:open', () => {
    if (!lenis) return;
    disableLenis();
  });

  document.addEventListener('product-media-modal:close', () => {
    if (!prefersReduce && mqDesktop.matches && !lenis) {
      enableLenis();
      if (hasGSAP()) {
        ScrollTrigger.refresh();
      }
    }
  });


  document.addEventListener('toggle-menu:open', () => {

    // Parar Lenis para bloquear scroll de verdad
    if (lenis) {
      try {
        lenis.stop();
        document.documentElement.classList.add('lenis-stopped');
      } catch (e) {
        console.warn('Error al parar Lenis (menu-open):', e);
      }
    }
  });

  document.addEventListener('toggle-menu:close', () => {

    // Reanudar Lenis solo si estamos en desktop
    if (!prefersReduce && mqDesktop.matches && lenis) {
      try {
        lenis.start();
        document.documentElement.classList.remove('lenis-stopped');
      } catch (e) {
        console.warn('Error al reanudar Lenis (menu-open):', e);
      }
    }
  });

  // ---------- Modo: escritorio vs móvil ----------
  let mode = 'unset'; // 'desktop' | 'mobile'

  function enterDesktop() {
    if (mode === 'desktop' || prefersReduce) return;
    enableLenis();
    enableBridge();
    enableParallax();
    if (hasGSAP()) requestAnimationFrame(() => ScrollTrigger.refresh());
    mode = 'desktop';
  }

  function enterMobile() {
    if (mode === 'mobile' || prefersReduce) return;
    disableParallax();
    disableBridge();
    disableLenis();
    mode = 'mobile';
  }

  function applyModeFromMQ() {
    if (prefersReduce) return;
    if (mqDesktop.matches) enterDesktop();
    else enterMobile();
  }

  // ---------- Arranque ----------
  document.addEventListener('DOMContentLoaded', () => {
  applyModeFromMQ();

  // 👇 Buscar el <details> del menú hamburguesa
  const menuDetails =
    document.querySelector('menu-drawer details') ||               // Dawn moderno
    document.querySelector('details.menu-drawer-container') ||     // fallback
    document.querySelector('#Details-menu-drawer-container');      // fallback

  if (menuDetails) {
    menuDetails.addEventListener('toggle', () => {
      if (menuDetails.open) {
        document.dispatchEvent(new Event('toggle-menu:open'));
      } else {
        document.dispatchEvent(new Event('toggle-menu:close'));
      }
    });
  }
});

  if (mqDesktop.addEventListener) {
    mqDesktop.addEventListener('change', applyModeFromMQ);
  } else if (mqDesktop.addListener) {
    mqDesktop.addListener(applyModeFromMQ);
  }

  const menuDrawer = document.querySelector('details#menu-drawer');

  if (menuDrawer) {
    menuDrawer.addEventListener('toggle', () => {
      if (menuDrawer.open) {
        document.dispatchEvent(new Event('toggle-menu:open'));
      } else {
        document.dispatchEvent(new Event('toggle-menu:close'));
      }
    });
  }

  // --- Clase al abrir/cerrar modal de producto ---
  document.addEventListener('product-media-modal:open', () => {
    document.documentElement.classList.add('media-modal-open');
  });

  document.addEventListener('product-media-modal:close', () => {
    document.documentElement.classList.remove('media-modal-open');
  });

})();

